import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import routes from '../routes/routes'
import customLabelService from '../services/customLabel.service'
import customLabelApi, { CustomLabelData } from '../apis/customLabel.api'
import Button from '../components/Button'
import Card from '../components/Card'
import CardButton from '../components/CardButton'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import PageHeading from '../components/PageHeading'
import TableVertical, { TableVerticalHeader } from '../components/TableVertical'

interface RouteState {
  id: number
}

interface Props extends RouteComponentProps<any, any, RouteState> {}

interface State {
  customLabel: CustomLabelData | null
}

class CustomLabel extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      customLabel: null
    }
  }

  headers: TableVerticalHeader[] = [
    { heading: i18n('Name'), path: 'name' },
    { heading: i18n('Item'), path: 'item.code' },
    { heading: i18n('CSV'), downloadText: 'csvFilename', path: 'downloadUrls.csv' },
    { heading: i18n('API'), downloadText: 'apiUrl', path: 'downloadUrls.api' },
    { heading: i18n('CSV prints'), path: 'csvPrints' },
    { heading: i18n('API prints'), path: 'apiPrints' }
  ]

  get id () {
    return this.props.location.state.id
  }

  get heading () {
    const { customLabel } = this.state
    const nameText = customLabel ? `: ${customLabel.name}` : ''
    return `Custom label${nameText}`
  }

  get table () {
    const { customLabel } = this.state
    if (!customLabel) return null
    const data = customLabelService.viewTableVerticalData(customLabel)
    return (
      <TableVertical
        headers={this.headers}
        data={data} />
    )
  }

  route = (pathname: string) => {
    const state = { id: this.id }
    this.props.history.push({ pathname, state })
  }

  handlePrintClick = () => {
    this.route(routes.customLabelPrint)
  }

  handleEditClick = () => {
    this.route(routes.customLabelEdit)
  }

  read = () => {
    customLabelApi.read(this.id, customLabel => {
      if (!customLabel) return
      this.setState({ customLabel })
    })
  }

  componentDidMount () {
    this.read()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="half">
          <Card>
            <PageHeading text={this.heading} />
            {this.table}
            <CardButton
              proceedText={i18n("Print")}
              cancelText={i18n("Back")}
              onProceedClick={this.handlePrintClick}>
              <Button
                text={i18n("Edit")}
                onClick={this.handleEditClick} />
            </CardButton>
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

export default withRouter(CustomLabel)
